import React from "react";
import Section from "../../../styles/Section.js";
import { Highlight } from "../../../styles/Utilities.js";
import { H3 } from "../../../styles/Headings.js";
import { P2, P3 } from "../../../styles/Paragraphs.js";
import Button from "../../../styles/Button.js";
import Image from "../../../components/Image.js";
import {
   Articles,
   Article,
   ArticleBody,
   ArticleButton
} from "./ArticlesSectionStyles.js";
import InView from "react-intersection-observer";

const articleVariant = {
   hidden: {
      y: 50,
      opacity: 0,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.4
         },
         opacity: {
            duration: 0.4
         }
      }
   },
   visible: i => ({
      y: 0,
      opacity: 1,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.4,
            delay: i
         },
         opacity: {
            duration: 0.4,
            delay: i
         }
      }
   })
};

function ArticlesSectionContainer() {
   return (
      <Section id="articles">
         <H3 center>
            <Highlight>Articles</Highlight> I've Written
         </H3>
         <P2
            center
            style={{ width: "49rem", maxWidth: "100%", margin: "1.2rem auto" }}
         >
            Recently, I started writing articles on dev.to with the motive to
            discuss ideas and to fully understand a topic until I am able to
            explain it. This makes me feel confident of what I learned. I look
            forward to interact, share and learn with the other enthusiasts.
         </P2>

         <InView threshold={0.25}>
            {({ ref, inView }) => (
               <Articles ref={ref}>
                  <Article
                     custom={0}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={articleVariant}
                  >
                     <Image
                        className="article-img"
                        src="populate-in-mongoose-article.png"
                        alt="populate in mongoose article"
                     />
                     <ArticleBody>
                        <P2 fontMain dark style={{ fontWeight: 500 }}>
                           Populate in mongoose & node.js
                        </P2>
                        <P3
                           className="article-text"
                           style={{ fontWeight: 300 }}
                        >
                           While working on a MERN stack project, I came across
                           a situation where I wanted to populate a field ...
                        </P3>
                        <ArticleButton
                           as="a"
                           href="https://dev.to/paras594/how-to-use-populate-in-mongoose-node-js-mo0"
                           target="_blank"
                           inverse
                        >
                           Read Now
                        </ArticleButton>
                     </ArticleBody>
                  </Article>
                  <Article
                     custom={0.3}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={articleVariant}
                  >
                     <Image
                        className="article-img"
                        src="mongo-article.png"
                        alt="mongo article"
                     />
                     <ArticleBody>
                        <P2 fontMain dark style={{ fontWeight: 500 }}>
                           Let’s Learn MongoDB (Series)
                        </P2>
                        <P3
                           className="article-text"
                           style={{ fontWeight: 300 }}
                        >
                           Currently, I am starting my journey to expand my
                           knowledge in MongoDB, and I have decided to create
                           this series ...
                        </P3>
                        <ArticleButton
                           as="a"
                           href="https://dev.to/paras594/learn-mongodb-getting-started-55nk"
                           target="_blank"
                           inverse
                        >
                           Read Now
                        </ArticleButton>
                     </ArticleBody>
                  </Article>
                  <Article
                     custom={0.5}
                     initial="hidden"
                     animate={inView ? "visible" : ""}
                     variants={articleVariant}
                  >
                     <Image
                        className="article-img"
                        src="cpp-stopwatch-article.jpg"
                        alt="cpp stopwatch article"
                     />
                     <ArticleBody>
                        <P2 fontMain dark style={{ fontWeight: 500 }}>
                           Let’s make a stopwatch with C++
                        </P2>
                        <P3
                           className="article-text"
                           style={{ fontWeight: 300 }}
                        >
                           I will show you how to create a simple stopwatch with
                           C++. I got this idea from my javascript stopwatch
                           project ...
                        </P3>
                        <ArticleButton
                           as="a"
                           href="https://dev.to/paras594/create-stopwatch-with-c-46bp"
                           target="_blank"
                           inverse
                        >
                           Read Now
                        </ArticleButton>
                     </ArticleBody>
                  </Article>
               </Articles>
            )}
         </InView>
         <div style={{ textAlign: "center", marginTop: "1.4rem" }}>
            <Button as="a" href="https://dev.to/paras594" target="_blank">
               View More at Dev.to
            </Button>
         </div>
      </Section>
   );
}

export default ArticlesSectionContainer;
